<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày phụ huynh gửi video')"
                  v-model="item.listDatePhVideo"
                  v-validate="'required'"
                  :defaultValue="item.listDatePhVideo ? true : false"
                  @clearText="clearDropDate"
                  clearable
              />
            </v-flex>
            <v-flex xs12 >
              <v-autocomplete
                  :items="classs"
                  :label="$t('Tên lớp')"
                  v-model="item.classId"
                  name="classId"
                  item-value="classId"
                  item-text="className"
                  v-validate="'required'"
                  :data-vv-as="$t('Tên lớp')"
                  :error-messages="errors.first('classId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="ZaloPH(item.classId)"
              />
            </v-flex>
            <v-flex xs12 v-if="checkOpenZalo == true">
              <v-autocomplete
                  :items="zaloPHs"
                  :label="$t('Tên zalo PH')"
                  v-model="item.zaloPH"
                  name="zaloPH"
                  item-value="zaloPH"
                  item-text="zaloPH"
                  v-validate="'required'"
                  :data-vv-as="$t('Tên zalo PH')"
                  :error-messages="errors.first('zaloPH')"
              />
            </v-flex>
            <v-flex xs12 v-if="checkOpenZalo == false">
              <v-text-field
                  type="text"
                  :label="$t('Tên zalo PH')"
                  v-model.trim="item.zaloPH"
                  name="zaloPH"
                  maxLength="200"
                  v-validate="'required'"
                  :error-messages="errors.first('zaloPH')"
                  :data-vv-as="$t('Tên zalo PH')"
              ></v-text-field>
            </v-flex>
<!--            <v-flex xs12>
              <v-select
                  :items="typeStatus"
                  :label="$t('Type')"
                  v-model="item.type"
                  name="type"
                  v-validate="'required'"
                  item-value="value"
                  item-text="text"
                  :data-vv-as="$t('Type')"
                  :error-messages="errors.first('type')"
              />
            </v-flex>-->
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Link bài tập')"
                  v-model.trim="item.linkVideo"
                  name="linkVideo"
                  maxLength="200"
                  v-validate="'required'"
                  :error-messages="errors.first('linkVideo')"
                  :data-vv-as="$t('Link bài tập')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                  :items="missions"
                  :label="$t('Nhiệm vụ')"
                  v-model="item.missionId"
                  name="missionId"
                  item-value="missionId"
                  item-text="missionName"
                  :data-vv-as="$t('Nhiệm vụ')"
                  :error-messages="errors.first('missionId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.missionId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nhận xét')"
                  v-model.trim="item.noteReview"
                  name="noteReview"
                  :error-messages="errors.first('noteReview')"
                  :data-vv-as="$t('Nhận xét')"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                  :items="users"
                  :label="$t('Giáo viên nhận xét')"
                  v-model="item.userId"
                  name="userId"
                  item-value="userId"
                  item-text="userName"
                  :data-vv-as="$t('Giáo viên nhận xét')"
                  :error-messages="errors.first('userId')"
                  :disabled="item.role = '27' ? false : true"
                  v-on:change="levelChange(item.userId)"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment";
import {typeStatus} from "@/constants/areaConstants";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    checkOpenZalo: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    levels: {
      type: Array,
      default: [],
    },
    zaloPHs: {
      type: Array,
      default: [],
    },

    users: {
      type: Array,
      default: [],
    },
    missions: {
      type: Array,
      default: [],
    },
    classs: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      typeStatus: areaContants.typeStatus,
      item: {
        missionReviewId: "",
        listDatePhVideo: "",
        classId: "",
        zaloPH: "",
        type: "",
        linkVideo: "",
        missionId: "",
        noteReview: "",
        userId: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        console.log(value);
        if (value !== null) {
          this.item = {
            missionReviewId: value.missionReviewId,
            listDatePhVideo: value.listDatePhVideo
                ? value.listDatePhVideo
                : "",
            classId: value.classId
                ? value.classId
                : "",
            zaloPH: value.zaloPH
                ? value.zaloPH
                : "",
            type: value.type
                ? value.type
                : "",
            linkVideo: value.linkVideo
                ? value.linkVideo
                : "",
            missionId: value.missionId
                ? value.missionId
                : "",
            noteReview: value.noteReview
                ? value.noteReview
                : "",
            userId: value.userId
                ? value.userId
                : "",
            role:value.role
                ? value.role
                : "",
            accountId:value.accountId
                ? value.accountId
                : "",
            status: value.status ? value.status : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    clearDropDate() {
      this.item.listDate = '';
      this.item.listDatePhVideo = '';
      this.item.dateReview = '';
      this.item.dateSendReview = '';
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    resetFrom: function () {
      this.item = {
        missionReviewId: "",
        listDatePhVideo: "",
        classId: "",
        zaloPH: "",
        type: "",
        linkVideo: "",
        missionId: "",
        noteReview: "",
        userId: "",
      };
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    ZaloPH(classId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidAccountClass/listAllNameByClassId/"+ classId, {status: 1}
      )
          .then(
              (data) => {
                console.info("aaaaaaa"+JSON.stringify(data))
                if (data.length > 0) {
                  this.zaloPHs = data;
                }
              }
          );
    },

    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidMissionReviewCheck/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.classs = data;
              }
            }
        );



    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/kidMission/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.missions = data;
              }
            }
        );

    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/user/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.users = data;
              }
            }
        );
  },
};
</script>
